import {Component, OnInit} from '@angular/core';
import {CardModule} from "primeng/card";
import {IPoliticaDatos} from "../../../shared/interfaces/configuracion";
import {DividerModule} from "primeng/divider";
import {InstructivosService} from "../../../services/instructivos.service";
import {LoadingPanelService} from "lib-base";
import {firstValueFrom, forkJoin} from "rxjs";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-politica-datos',
  standalone: true,
  imports: [
    CardModule,
    DividerModule
  ],
  templateUrl: './politica-datos.component.html',
  styleUrl: './politica-datos.component.scss'
})
export class PoliticaDatosComponent implements OnInit {

  politicaDatos: IPoliticaDatos[] = [];
  translations:any = {};
  private readonly idFile: number = 1;

  constructor(private instructivosService: InstructivosService,
              private messageService: MessageService,
              private readonly _t:TranslateService,
              private readonly _lps: LoadingPanelService) {

  }



  ngOnInit(): void {
    this.initTranslate().then(() => this.initPoliticaDatos());
  }

  initPoliticaDatos() {
    this.politicaDatos = [
      {
        title: this.translations.titleLey,
        content: this.translations.contentLey
      }, {
        title: this.translations.titleQueSon,
        content: this.translations.contentQueSon
      }, {
        title: this.translations.comoRecogenDatos,
        content: this.translations.contentComoRecogenDatos
      }
    ];
  }

  async initTranslate() {
    this.translations = await firstValueFrom(forkJoin({
      header: this._t.get('components.app-politica-datos.header'),
      warnSumary: this._t.get('form.msg.warn-summary'),
      consultaDocumento: this._t.get('components.app-politica-datos.consulta-documento'),
      nombreDocumento: this._t.get('components.app-politica-datos.nombre-documento'),
      warnDetail: this._t.get('components.app-politica-datos.warn-message'),
      titleLey: this._t.get('components.app-politica-datos.ley'),
      contentLey: this._t.get('components.app-politica-datos.ley-text'),
      titleQueSon: this._t.get('components.app-politica-datos.que-son'),
      contentQueSon: this._t.get('components.app-politica-datos.que-son-text'),
      comoRecogenDatos: this._t.get('components.app-politica-datos.como-recogen-datos'),
      contentComoRecogenDatos: this._t.get('components.app-politica-datos.como-recogen-datos-text'),
    }));
  }

  async getDocumento() {
    this._lps.show();
    try {
      const value = await firstValueFrom(this.instructivosService.getDocumentoByID(this.idFile));
      if (value.size > 0) {
        const anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(value);
        anchor.target = '_blank';
        anchor.click();
      }else{
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.warnSumary ,
          detail: this.translations.warnDetail
        });
      }
      this._lps.hide();

    } catch (err) {
       this._lps.hide();
    }
  }
}
